import { AxiosResponse } from 'axios';
import { useDispatch } from 'react-redux';
import {snackbar, dialog401} from 'actions'
import { AlertProps } from '@material-ui/lab';

interface UseSnackbarCallbackArgs {
  message: string,
  noBackdrop?: boolean,
  severity?: AlertProps['severity'],
  response?: AxiosResponse
}

const useSnackbar = (): (args: UseSnackbarCallbackArgs) => void => {
  const dispatch = useDispatch();

  return ({ message, noBackdrop = false, severity = 'error', response = {} as AxiosResponse }) => {
    if(response.status === 401) {
      dispatch(dialog401({message: response.data || message, severity, noBackdrop}))
    } else {
      dispatch(snackbar({message: response.data || message, severity, noBackdrop}))
    }
  }
};

export default useSnackbar;